import { render, staticRenderFns } from "./dialog-add-signup.vue?vue&type=template&id=5acbfa22&scoped=true"
import script from "./dialog-add-signup.vue?vue&type=script&lang=js"
export * from "./dialog-add-signup.vue?vue&type=script&lang=js"
import style0 from "./dialog-add-signup.vue?vue&type=style&index=0&id=5acbfa22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acbfa22",
  null
  
)

export default component.exports